/**
 * @generated SignedSource<<cc3d59979a40b7526d20ea929264a819>>
 * @relayHash 30b56244c1b7e036e52debb35dd6fcf2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9561e4e88b317e2954d5ed9798719aaa143c5c332b9bc9b9f0da41947c9216b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateLabelsFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraLabelsFieldOperationInput>;
};
export type JiraLabelsFieldOperationInput = {
  labels: ReadonlyArray<string>;
  operation: JiraMultiValueFieldOperations;
};
export type useSaveLabelsField_LabelsMutation$variables = {
  input: JiraUpdateLabelsFieldInput;
};
export type useSaveLabelsField_LabelsMutation$data = {
  readonly jira: {
    readonly updateLabelsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSaveLabelsField_LabelsMutation$rawResponse = {
  readonly jira: {
    readonly updateLabelsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldConfig: {
          readonly isEditable: boolean | null | undefined;
        } | null | undefined;
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly selectedLabelsConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSaveLabelsField_LabelsMutation = {
  rawResponse: useSaveLabelsField_LabelsMutation$rawResponse;
  response: useSaveLabelsField_LabelsMutation$data;
  variables: useSaveLabelsField_LabelsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSaveLabelsField_LabelsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraLabelsFieldPayload",
            "kind": "LinkedField",
            "name": "updateLabelsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraLabelsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveLabelsField_LabelsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraLabelsFieldPayload",
            "kind": "LinkedField",
            "name": "updateLabelsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraLabelsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                      }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "totalCount"
                      },
                      {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d9561e4e88b317e2954d5ed9798719aaa143c5c332b9bc9b9f0da41947c9216b",
    "metadata": {},
    "name": "useSaveLabelsField_LabelsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8ad20115daf17ea5e9001db36624cdd7";

export default node;
